import Link from 'next/link';

import { CheckIcon } from '@/components/LandingPage/CheckIcon';
import { Container } from '@/components/LandingPage/Container';

export function Introduction() {
  return (
    <section
      id="introduction"
      aria-label="Introduction"
      className="pt-20 pb-16 sm:pb-20 md:pt-36 lg:py-32"
    >
      <Container className="text-lg tracking-tight text-slate-700">
        <p className="font-display text-4xl font-bold tracking-tight text-slate-900">
          Wszystko zaczyna się od słowa. To ono daje nam książkę.
        </p>
        <p className="mt-4">
          Tak samo jest z nami, ludźmi. Jeden bibliofil ma małe
          znaczenie ale razem, tworzymy już pokaźną biblioteczkę. 
          Katalogowanie papierowych książek to tworzenie społeczności opartej na czymś
          wartościowym i trwałym. 
        </p>
        <p className="mt-4">
          Możesz skorzystać z wszystkiego lub tylko skatalogować swój zbiór. W pakiecie po zarejestrowaniu masz możliwość do: 
        </p>
        <ul role="list" className="mt-8 space-y-3">
          {[
            'Kontaktu z przyszłymi czytelnikami Twoich książek.',
            'Kontaktu z Twoimi czytelnikami (jeśli jesteś autorką/autorem).',
            'Dodawania recenzji pisanych i mówionych.',
            'Błyskawicznego skatalogowania nawet pokaźnego zbioru.',
          ].map((feature) => (
            <li key={feature} className="flex">
              <CheckIcon className="h-8 w-8 flex-none fill-blue-500" />
              <span className="ml-4">{feature}</span>
            </li>
          ))}
        </ul>
        <p className="mt-10">
          <Link href="/docs" className="text-base font-medium text-teal-600 hover:text-teal-800">
            Zajrzyj do dokumentacji i przeczytaj więcej <span aria-hidden="true">&rarr;</span>
          </Link>
        </p>
      </Container>
    </section>
  );
}
